import React, { useState, useEffect, useRef } from 'react';
import {
	Button,
	CircularProgress,
	Container,
	Grid,
	Paper,
	Typography,
} from 'components/mui';
import { default as DataTable } from 'containers/pages/CANreports/MUI/MuiTable';
import { default as DatePicker } from 'containers/pages/CANreports/MUI/MuiDatePicker';
import { getColumns, GetShiftReport, modifyData } from './Helper';
import { CSVLink, CSVDownload } from 'react-csv';
import { Calendar, momentLocalizer } from 'react-big-calendar';
import moment from 'moment';
import 'react-big-calendar/lib/css/react-big-calendar.css';

const localizer = momentLocalizer(moment);
// import styled from 'styled-components';

const ShiftReport = () => {
	const [data, setData] = useState({});
	const [clicked, setClicked] = useState(false);
	const [shiftTableData, setShiftTableData] = useState([]);
	const [pending, setPending] = useState(false);
	const [startDate, setStartDate] = useState('2022-05-01T06:00:00.000Z');
	const [endDate, setEndDate] = useState('2022-05-31T06:00:00.000Z');
	const [columns, setColumns] = useState([]);
	const csvLinkRef = useRef(); // Create a reference
	const [expandedGuard, setExpandedGuard] = useState(null);
	const [calendarDate, setCalendarDate] = useState(startDate); // or any default date

	const fetchReport = () => {
		setClicked(true);
		setPending(true);
		setExpandedGuard(null);
		GetShiftReport(startDate, endDate).then((rep) => {
			const report = modifyData(rep, startDate, endDate);
			setData(report.shiftReport);
			setShiftTableData(report.tableData);
			setCalendarDate(startDate);
			setPending(false);
		});
		setColumns(getColumns(startDate, endDate, setExpandedGuard));
	};

	const options = {
		filter: true,
		filterType: 'dropdown',
		responsive: 'standard',
		fixedHeader: true,
		fixedSelectColumn: false,
	};

	function transformDataForExport(data) {
		return data.map((row) => {
			const newRow = { ...row };
			Object.keys(newRow).forEach((key) => {
				if (newRow[key] === 0) {
					newRow[key] = '';
				}
			});
			return newRow;
		});
	}

	const guardEvents = (guard) => {
		const events = [];
		Object.keys(guard).forEach((key) => {
			if (key.includes('-') && guard[key] > 0) {
				events.push({
					start: new Date(key),
					end: new Date(key),
					title: `${guard[key]} shifts`,
				});
			}
		});
		return events;
	};

	// useEffect(() => {
	// 	setCalendarDate(startDate);
	// }, [startDate]);

	return (
		<Container maxWidth="xl">
			<Paper style={{ padding: '24px' }}>
				<Grid
					container
					spacing={3}
					alignItems="center"
					justifyContent="center"
				>
					<Grid item xs={12} sm={4}>
						<DatePicker
							fullWidth
							views={['year', 'month']}
							label="Select Month & Year"
							format="MMMM yyyy"
							value={startDate} // Using startDate as the value for simplicity
							onChange={(date) => {
								setStartDate(
									new Date(
										date.getFullYear(),
										date.getMonth(),
										1,
									).toISOString(),
								);
								setEndDate(
									new Date(
										date.getFullYear(),
										date.getMonth() + 1,
										0,
									).toISOString(),
								);
							}}
						/>
					</Grid>

					<Grid item xs={12} sm={4}>
						<Button
							fullWidth
							onClick={() => fetchReport()}
							variant="contained"
							color="primary"
						>
							Fetch report
						</Button>
					</Grid>
					{pending ? (
						<div
							style={{
								display: 'flex',
								justifyContent: 'center',
							}}
						>
							<CircularProgress />
						</div>
					) : (
						<>
							<Grid item xs={12} sm={4}>
								{shiftTableData.length > 0 && (
									<>
										<div>
											{/* This is your hidden CSVLink */}
											<CSVLink
												data={transformDataForExport(
													shiftTableData,
												)}
												filename="ShiftRpt.csv"
												ref={csvLinkRef}
												style={{ display: 'none' }} // This hides the CSVLink
											>
												Download
											</CSVLink>

											{/* This is your MUI Button which triggers the hidden CSVLink */}
											<Button
												fullWidth
												variant="contained"
												color="primary"
												onClick={() =>
													csvLinkRef.current.link.click()
												} // Programmatically click the CSVLink
											>
												Download Report Data
											</Button>
										</div>
									</>
								)}
							</Grid>
							<Grid item xs={12}>
								{shiftTableData.length > 0 && (
									<>
										<Typography
											variant="h5"
											align="center"
											gutterBottom
										>
											Report Ready
										</Typography>
									</>
								)}
							</Grid>
							<Grid item xs={12} lg={6}>
								{shiftTableData.length > 0 && (
									<>
										<DataTable
											rows={shiftTableData}
											columns={columns}
											options={options}
										/>
									</>
								)}
							</Grid>
							<Grid item xs={12} lg={6}>
								{expandedGuard && (
									<div
										style={{
											height: 500,
											marginTop: '20px',
										}}
									>
										<Typography variant="h6">
											Shift details for:{' '}
											{expandedGuard.name}
										</Typography>
										<Calendar
											localizer={localizer}
											events={guardEvents(expandedGuard)}
											views={{
												month: true,
												week: true,
												day: false, // Explicitly set to false
												agenda: true,
											}}
											startAccessor="start"
											endAccessor="end"
											date={new Date(calendarDate)}
											onNavigate={(newDate) =>
												setCalendarDate(
													newDate.toISOString(),
												)
											}
											style={{
												height: 400,
												marginTop: '10px',
											}}
										/>
									</div>
								)}
							</Grid>
						</>
					)}
				</Grid>
			</Paper>
		</Container>
	);
};

export default ShiftReport;
